export type AssetIconVisualState = "loading" | "initials" | "remote";

export interface AssetIconDeriveInput {
  name: string;
  baseUrl: string | undefined;
  isManifestLoading: boolean;
  availableSymbols: ReadonlySet<string> | null;
  symbolsWithDark: ReadonlySet<string> | null;
  failedLightLogos: ReadonlySet<string>;
}

export interface AssetIconDeriveOutput {
  visualState: AssetIconVisualState;
  normalizedSymbol: string;
  hasDarkVariant: boolean;
  lightSrc: string | undefined;
  darkSrc: string | undefined;
  initials: string;
}

export function normalizeLogoSymbol(symbol: string): string {
  return symbol.replaceAll("/", "-");
}

export function lightFailedKey(symbol: string): string {
  return `${symbol}:light`;
}

export function deriveAssetIconState(
  input: AssetIconDeriveInput,
): AssetIconDeriveOutput {
  const {
    name,
    baseUrl,
    isManifestLoading,
    availableSymbols,
    symbolsWithDark,
    failedLightLogos,
  } = input;
  const normalizedSymbol = normalizeLogoSymbol(name);
  const initials = name.slice(0, 2).toUpperCase();

  if (baseUrl && isManifestLoading) {
    return {
      visualState: "loading",
      normalizedSymbol,
      hasDarkVariant: false,
      lightSrc: undefined,
      darkSrc: undefined,
      initials,
    };
  }

  const symbolInManifest = availableSymbols?.has(name) ?? false;
  const hasDarkVariant = symbolsWithDark?.has(name) ?? false;

  if (
    baseUrl &&
    symbolInManifest &&
    !failedLightLogos.has(lightFailedKey(name))
  ) {
    return {
      visualState: "remote",
      normalizedSymbol,
      hasDarkVariant,
      lightSrc: `${baseUrl}/${normalizedSymbol}.svg`,
      darkSrc: `${baseUrl}/dark/${normalizedSymbol}.svg`,
      initials,
    };
  }

  return {
    visualState: "initials",
    normalizedSymbol,
    hasDarkVariant: false,
    lightSrc: undefined,
    darkSrc: undefined,
    initials,
  };
}
